var $ = global.$ = global.jQuery;

/**
 * This is a basic PubSub (Publish and Subscribe) implementation using jQuery. The basic premise is that one event can have many subscribers. Useful if you have a lot of different actions to perform off the back of the same events, and where you can't use Promises.
 * @exports lib/ps
 * @author Simon Buerger
 */
var ps = {
  eventObj: $({}),
  /**
   * Subscribe to all of the events with this name. Same external API as jQuery .on()
   * @instance
   */
  subscribe: function(){
    this.eventObj.on.apply(this.eventObj, arguments);
  },
  /**
   * Subscribe to the first of the events with this name. Same external API as jQuery .one()
   * @instance
   */
  subscribeOnce: function(){
    this.eventObj.one.apply(this.eventObj, arguments);
  },
  /**
   * Unsubscribe from all of the events with this name. Same external API as jQuery .off()
   * @instance
   */
  unsubscribe: function(){
    this.eventObj.off.apply(this.eventObj, arguments);
  },
  /**
   * Trigger an event with this name and arguments. Same external API as jQuery .trigger()
   * @instance
   */
  publish: function(){
    this.eventObj.trigger.apply(this.eventObj, arguments);
  }
};

module.exports = ps;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/lib/ps.js
// module id = 4
// module chunks = 0